//store representing customers
import { defineStore } from 'pinia'
import type { ProjectInfo } from '@/types/types'
import axios from '../libs/axios'
import type { Customer } from '@/types/types'
import { customerSchema } from '@/types/types'
import { useAlertStore } from '@/stores'
//import { customerSchema } from '@/types/types'
import * as yup from 'yup'
import router from '@/router'
import { formatDate } from '@/libs/utils'

const postechCalcSchema = yup.object({
  fileName: yup.string().required(),
  folderId: yup.string().required(),
  projectId: yup.string().required(),
  address: yup.string().required(),
  engineer: yup.string().required(),
  date: yup.string().required()
})

const checksheetSchema = yup.object({
  fileName: yup.string().required(),
  folderId: yup.string().required(),
  projectId: yup.string().required(),
  address: yup.string().required(),
  engineer: yup.string().required(),
  date: yup.string().required(),
  checker: yup.string().required()
})

const genericLetterSchema = yup.object({
  customer: yup.string().required(),
  streetAddress: yup.string().required(),
  city: yup.string().required(),
  province: yup.mixed().oneOf(['AB', 'BC', 'SK', 'MB', 'ON', 'NB', 'NS']).required(),
  // paragraph2: yup.string().required(),
  //  paragraph3: yup.string().required(),
  // paragraph4: yup.string().required(),
  //name: yup.string(),
  //  buildingCode: yup.string().required(),
  CofA: yup.string().required(),
  email: yup.string().required(),
  name: yup.string().required(),
  folderId: yup.string().required(),
  filename: yup.string().required(),
  date: yup.string().required()
})

export const useFileStore = defineStore('files', () => {
  async function createPostechCalc(project: ProjectInfo) {
    console.log('files store createPostechCalc()...')
    const alert = useAlertStore()
    alert.loading('..creating postech calc from google template...');
    //try form validation
    const fileName = `${project.name}-pilecalc`
    const payload = {
      fileName: fileName,
      folderId: project.folderId,
      projectId: project.id,
      address: project.name,
      engineer: project.engineer.email,
      date: formatDate(new Date())
    }
    
    let parsed
    try {
      parsed = await postechCalcSchema.validate(payload, { stripUnknown: true }) //remove extra fields
      console.log('parsed = ' + JSON.stringify(parsed))
    } catch (err) {
      //err.name; // => 'ValidationError'
      //err.errors; // => ['Deve ser maior que 18']
      console.log(err)
      alert.error(err)
      setTimeout(() => {
        alert.clear()
      }, 3000)
      return
    }
    //if form is valid:
    if (parsed) {
      //let response = null;
      axios
        .post(`/gdrive/createPostechCalc`, parsed)
        .then((res) => {
          alert.success(res.data.message)
          setTimeout(() => {
            alert.clear()
            //push to new project
            //const projectId = res.data.data.project.id;
            // router.push(`/projects/${projectId}/details`);
          }, 3000)
        })
        .catch((error) => {
          if (error.response) {
            alert.error(error.response.data)
          } else if (error.request) {
            alert.error(error.request)
          }
        })
    }
  }

  async function createChecksheet(project: ProjectInfo) {
    console.log('files store createChecksheet()...')
    const alert = useAlertStore()
    alert.loading('..creating check sheet from google template...');
    //try form validation
    const fileName = `${project.name}-checksheet`
    const payload = {
      fileName: fileName,
      folderId: project.folderId,
      projectId: project.id,
      address: project.name,
      engineer: project.engineer.email,
      date: formatDate(new Date()),
      checker: project.checker
    }
   
    let parsed
    try {
      parsed = await checksheetSchema.validate(payload, { stripUnknown: true }) //remove extra fields
      console.log('parsed = ' + JSON.stringify(parsed))
    } catch (err) {
      //err.name; // => 'ValidationError'
      //err.errors; // => ['Deve ser maior que 18']
      console.log(err)
      alert.error(err)
      setTimeout(() => {
        alert.clear()
      }, 3000)
      return
    }
    //if form is valid:
    if (parsed) {
      //let response = null;
      axios
        .post(`/gdrive/createChecksheet`, parsed)
        .then((res) => {
          alert.success(res.data.message)
          setTimeout(() => {
            alert.clear()
            //push to new project
            //const projectId = res.data.data.project.id;
            // router.push(`/projects/${projectId}/details`);
          }, 3000)
        })
        .catch((error) => {
          if (error.response) {
            alert.error(error.response.data)
          } else if (error.request) {
            alert.error(error.request)
          }
        })
    }
  }

  /**
   * create generic letter
   */
  async function createGenericLetter(payload: Object) {
    console.log('Postech store createGenericLetter()...')
    console.log('validating object : ' + JSON.stringify(payload))
    //try form validation
    const alert = useAlertStore()
    alert.loading('..creating generic letter from google template...');
    let parsed
    try {

      parsed = await genericLetterSchema.validate(payload, { stripUnknown: true }) //remove extra fields
      console.log('parsed = ' + JSON.stringify(parsed))
    } catch (err) {
      //err.name; // => 'ValidationError'
      //err.errors; // => ['Deve ser maior que 18']
      console.log(err)
      alert.error(err)
      setTimeout(() => {
        alert.clear()
      }, 3000)
      return
    }
    //if form is valid:
    if (parsed) {
      //let response = null;
      await axios
        .post('/gdrive/createGenericLetter', parsed)
        .then((res) => {
          alert.success(res.data.message)
          setTimeout(() => {
            alert.clear()
            // router.back();
          }, 3000)
        })
        .catch((error) => {
          if (error.response) {
            alert.error(error.response.data)
          } else if (error.request) {
            alert.error(error.request)
          }
        })
    }
  }

   async function createBeamCalc(project: ProjectInfo) {
    console.log('files store createBeamCalc()...')
    const alert = useAlertStore()
    alert.loading('..creating beam calc from google template...');
    //try form validation
    const fileName = `${project.name}-beamcalc`
    const payload = {
      fileName: fileName,
      folderId: project.folderId,
      projectId: project.id,
      address: project.name,
      engineer: project.engineer.email,
      date: formatDate(new Date())
    }
    
    let parsed
    try {
      parsed = await postechCalcSchema.validate(payload, { stripUnknown: true }) //remove extra fields
      console.log('parsed = ' + JSON.stringify(parsed))
    } catch (err) {
      //err.name; // => 'ValidationError'
      //err.errors; // => ['Deve ser maior que 18']
      console.log(err)
      alert.error(err)
      setTimeout(() => {
        alert.clear()
      }, 3000)
      return
    }
    //if form is valid:
    if (parsed) {
      //let response = null;
      axios
        .post(`/gdrive/createBeamCalc`, parsed)
        .then((res) => {
          alert.success(res.data.message)
          setTimeout(() => {
            alert.clear()
            //push to new project
            //const projectId = res.data.data.project.id;
            // router.push(`/projects/${projectId}/details`);
          }, 3000)
        })
        .catch((error) => {
          if (error.response) {
            alert.error(error.response.data)
          } else if (error.request) {
            alert.error(error.request)
          }
        })
    }
  }

  return { createPostechCalc, createChecksheet, createGenericLetter, createBeamCalc }
})
